export default __webpack_public_path__ + "static/media/logo.92107d3a.png";